import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';


import { createConfig, http } from 'wagmi'
import { coreDao } from 'wagmi/chains'
import { injected, metaMask, safe, walletConnect } from 'wagmi/connectors'

import { WagmiProvider } from 'wagmi'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'


const projectId = '877c463a741b5bd3313fac9778fb5b92'

//mainnet, sepolia

export const config = createConfig({
  chains: [coreDao],//[mainnet, sepolia],
  connectors: [
    injected(),
    walletConnect({ projectId }),
    metaMask(),
    safe(),
  ],
  transports: {
    [coreDao.id]: http(),
    // [mainnet.id]: http(),
    // [sepolia.id]: http(),
  },
})

const queryClient = new QueryClient()


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <WagmiProvider config={config}>
      {/* <React.StrictMode> */}
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
    {/* </React.StrictMode> */}
  </WagmiProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
